/**
 * @generated SignedSource<<708a2acb2a335d6b6933bc5afe507772>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SubspaceMenuList$data = {
  readonly id: string;
  readonly subspaces_cse: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null | undefined;
        readonly subspaceUrl: AGG$URL | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SubspaceMenuList";
};
export type SubspaceMenuList$key = {
  readonly " $data"?: SubspaceMenuList$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubspaceMenuList">;
};

import SubspaceMenuListRefetchQuery_graphql from './SubspaceMenuListRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [
        "node"
      ],
      "operation": SubspaceMenuListRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "SubspaceMenuList",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "concreteType": "JiraSubspaceConnection_CSE",
          "kind": "LinkedField",
          "name": "subspaces_cse",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraSubspaceEdge_CSE",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraSubspace_CSE",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "subspaceUrl"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "7d5e77ba7979f7d2d1b9fc0310bed1a4";

export default node;
